import type { ProductListResult } from '@partful/shared-types';
import { usePermissions } from 'src/hooks/usePermissions';
import { ProductCard } from './components/ProductCard';
import UploadProductCard from './components/UploadProductCard';
import { ProductListStyles } from './styles';

interface ProductListProps {
  products: ProductListResult[];
}

export default function ProductList({ products }: Readonly<ProductListProps>) {
  const showUploadTile = usePermissions(['add', 'product']);

  return (
    <ProductListStyles>
      {products.map((product) => (
        <ProductCard key={product.productId} product={product} />
      ))}
      {showUploadTile && <UploadProductCard />}
    </ProductListStyles>
  );
}
